import { render, staticRenderFns } from "./SchedaMorteEdit.vue?vue&type=template&id=005e30cd&scoped=true"
import script from "./SchedaMorteEdit.vue?vue&type=script&lang=js"
export * from "./SchedaMorteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005e30cd",
  null
  
)

export default component.exports